import { CoreBox, CoreTypography } from '@youscience/core';

import EducationPlannerHero from './components/EducationPlannerHero';
import EducationPlannerSchoolList from './components/EducationPlannerSchoolList';

import { useConnectCommonAppAccount } from './hooks';

import {
  StyledPageInnerContentMargin,
  StyledPageInnerContentSupportText,
  StyledDivider,
} from './EducationPlannerApplications.styles';

export const EducationPlannerApplications = () => {
  useConnectCommonAppAccount();

  return (
    <CoreBox>
      <EducationPlannerHero />

      <StyledPageInnerContentMargin>
        <StyledPageInnerContentSupportText>
          <CoreTypography>
            Manage all stages of your school applications. Customize your to-do checklists, keep track of your
            deadlines, and edit your school choices and decision statuses. Remember to discuss your plans and progress
            with your school counselor and parents or guardians.
          </CoreTypography>
        </StyledPageInnerContentSupportText>
      </StyledPageInnerContentMargin>

      <StyledDivider />

      <StyledPageInnerContentMargin>
        <EducationPlannerSchoolList />
      </StyledPageInnerContentMargin>
    </CoreBox>
  );
};
